<div class="home" data-testid="funae-home-container">
  <div class="body">
    <img src="/assets/images/funae/funae-logo.jpg" width="190px">
    <div class="help-banner">
      <h4>{{ 'home.questions-1' | translate }}</h4>
      <p>{{ 'home.questions-2' | translate }}</p>
    </div>
  </div>
</div>
